/**
 * Bakim presenter'i
 */

import { AppState } from '../../modules/state.js';
import { FirebaseService } from '../../shared/services/firebase.service.js';
import { COLLECTIONS, STATUS_LABELS } from '../../firebase-config.js';
import { formatDate } from '../../shared/utils/formatters.js';

interface MaintenancePresenterDeps {
    openModal: (modalId: string) => void;
    showToast: (message: string, type?: string) => void;
    generateId: () => string;
    escapeHtml: (value: string) => string;
}

export function renderMaintenancePresenter(deps: MaintenancePresenterDeps): void {
    const container = document.getElementById('maintenance-list');
    if (!container) return;

    if (AppState.maintenance.length === 0) {
        container.innerHTML = '<p class="empty-state">Henüz bakım kaydı eklenmemiş</p>';
        return;
    }

    const sorted = [...AppState.maintenance].sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
    container.innerHTML = sorted.map(item => {
        const dayDiff = Math.ceil((new Date(item.date).getTime() - Date.now()) / 86400000);
        const urgencyClass = item.status === 'completed' ? 'completed' : dayDiff < 0 ? 'overdue' : dayDiff <= 7 ? 'urgent' : 'normal';
        const urgencyText = item.status === 'completed'
            ? 'Tamamlandı'
            : dayDiff < 0
                ? `${Math.abs(dayDiff)} gün gecikmiş`
                : dayDiff <= 7
                    ? `${dayDiff} gün içinde`
                    : 'Planlı';

        return `
        <div class="maintenance-card maintenance-${urgencyClass}">
            <div class="maintenance-icon">${item.status === 'completed' ? '✅' : '🔧'}</div>
            <div class="maintenance-info">
                <h4>${deps.escapeHtml(item.title)}</h4>
                <p>${deps.escapeHtml(item.description || '-')}</p>
                <span class="maintenance-date">📅 ${formatDate(item.date)}</span>
                <span class="status-badge-sm ${item.status}">${STATUS_LABELS[item.status]}</span>
                <span class="maintenance-urgency">${urgencyText}</span>
            </div>
            <div class="maintenance-actions">
                <button class="btn btn-secondary btn-sm" onclick="editMaintenance('${item.id}')">✏️</button>
                <button class="btn btn-danger btn-sm" onclick="deleteMaintenance('${item.id}')">🗑</button>
            </div>
        </div>
    `;
    }).join('');
}

export function addMaintenancePresenter(data: Record<string, any>, deps: MaintenancePresenterDeps) {
    const maintenance = { id: deps.generateId(), ...data, createdAt: new Date().toISOString() };
    AppState.maintenance.push(maintenance);
    FirebaseService.add(COLLECTIONS.MAINTENANCE, maintenance);
    deps.showToast('Bakım kaydı eklendi', 'success');
    return maintenance;
}

export function updateMaintenancePresenter(id: string, data: Record<string, any>, deps: MaintenancePresenterDeps): boolean {
    const index = AppState.maintenance.findIndex(item => item.id === id);
    if (index === -1) return false;

    const updated = { ...AppState.maintenance[index], ...data };
    AppState.maintenance[index] = updated;
    FirebaseService.save(COLLECTIONS.MAINTENANCE, id, updated);
    deps.showToast('Bakım kaydı güncellendi', 'success');
    return true;
}

export function deleteMaintenancePresenter(id: string, deps: MaintenancePresenterDeps): void {
    if (!confirm('Bu bakım kaydını silmek istediğinizden emin misiniz?')) return;

    AppState.maintenance = AppState.maintenance.filter(item => item.id !== id);
    FirebaseService.delete(COLLECTIONS.MAINTENANCE, id);
    renderMaintenancePresenter(deps);
    deps.showToast('Bakım kaydı silindi', 'success');
}

export function editMaintenancePresenter(id: string, deps: MaintenancePresenterDeps): void {
    const maintenance = AppState.maintenance.find(item => item.id === id);
    if (!maintenance) return;

    document.getElementById('maintenance-modal-title')!.textContent = 'Bakım Düzenle';
    (document.getElementById('maintenance-id') as HTMLInputElement).value = maintenance.id;
    (document.getElementById('maintenance-title') as HTMLInputElement).value = maintenance.title;
    (document.getElementById('maintenance-date') as HTMLInputElement).value = maintenance.date;
    (document.getElementById('maintenance-description') as HTMLTextAreaElement).value = maintenance.description || '';
    (document.getElementById('maintenance-status') as HTMLSelectElement).value = maintenance.status;
    deps.openModal('maintenance-modal');
}
